import React from 'react'

import { useSortable } from '@dnd-kit/sortable'
import {CSS} from "@dnd-kit/utilities"
import "./Task.css"

export const Task = ({id, title, codeLanguage, onDelete, status}) => {
  const {attributes, listeners, setNodeRef, transform, transition} = useSortable({id, data: { type: "task", status }})

  const style ={
    transition,
    transform: CSS.Transform.toString(transform)
  }
  const languages = Array.isArray(codeLanguage)
  ? codeLanguage
  : [codeLanguage].filter(Boolean)

  return (
    <div className="task" ref={setNodeRef} {...attributes} {...listeners}style={style}>
      {title}
      <div className="languages">
        {languages.map(lang => (
        <span key={lang} className={`tag ${lang}`}>{lang}</span>
      ))}
      </div>
      <button
        className="deleteBtn"
        onPointerDown={(e) => e.stopPropagation()}
        onClick={(e) => {
          e.stopPropagation()
          onDelete(id)
         }}
        >
          ❌
      </button>
    </div>
  )
}
